import axios from "axios";
import { IMAGE_URL } from "../network/apiClient";

const WEBSITE_API_URL = "https://api.coloursboutique.com/api/website";

export const blogImageUrl = (file) => {
  if (!file) return "";
  if (file.url) return file.url;
  if (file.docPath && file.docName) return `${IMAGE_URL}${file.docPath}/${file.docName}`;
  return "";
};

class BlogApi {
  async list(params = {}) {
    const response = await axios.get(`${WEBSITE_API_URL}/blogs`, { params });
    return response.data;
  }

  async get(slug) {
    const response = await axios.get(`${WEBSITE_API_URL}/blogs/${slug}`);
    return response.data?.data;
  }

  async categories() {
    const response = await axios.get(`${WEBSITE_API_URL}/blog-categories`);
    return response.data?.data || [];
  }
}

const blogApi = new BlogApi();
export default blogApi;
